/**
 * use-autosize-textarea.ts — Ô nhập giãn theo nội dung tới một mức tối đa rồi mới cuộn bên trong (như ô chat của Claude, DingTalk).
 * Trước đây ô cố định một dòng (`rows=1`) nên gõ tin dài thì phần đầu bị che, người gõ không thấy mình đã viết gì.
 */
import { useLayoutEffect, type RefObject } from 'react'

/** Hàm thuần: chiều cao ô = nội dung, kẹp giữa `min` và `max` (px). */
export function autosizeHeight(scrollHeight: number, min: number, max: number): number {
  return Math.max(min, Math.min(scrollHeight, max))
}

/** Điện thoại: tối đa 40% vùng nhìn thấy (bàn phím mở thì vùng này nhỏ lại) — để vẫn còn chỗ cho tin nhắn phía trên. */
export function mobileMaxHeight(visibleHeight: number): number {
  return Math.max(96, Math.round(visibleHeight * 0.4))
}

export function useAutosizeTextarea(ref: RefObject<HTMLTextAreaElement | null>, value: string, opts: { min: number; max: number | (() => number) }): void {
  const { min, max } = opts
  useLayoutEffect(() => {
    const el = ref.current
    if (!el) return
    const fit = () => {
      const cap = typeof max === 'function' ? max() : max
      el.style.height = 'auto'
      el.style.height = `${autosizeHeight(el.scrollHeight, min, cap)}px`
      el.style.overflowY = el.scrollHeight > cap ? 'auto' : 'hidden'
    }
    fit()
    const vv = typeof window !== 'undefined' ? window.visualViewport : null
    vv?.addEventListener('resize', fit)
    return () => vv?.removeEventListener('resize', fit)
  }, [ref, value, min, max])
}
